<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
            <!-- <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddField" class="ml-auto">
                    <span class="color-white">
                        add field
                    </span>
                </el-button>
            </div> -->
            <el-card class="box-card">
                <el-table :data="allFields" style="width: 100%">
                    
                    
                    <el-table-column label="Field" prop="id"/>
                    <el-table-column label="title En" align="right">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

                   
                    <el-table-column label="description En" >
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').description}}
                        </template>
                    </el-table-column>

                    <el-table-column label="title Ar" align="right" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="description Ar"  >
                        <template #default="scope">
                           <div class="rtl text-right">
                               {{$getLocaleData(scope.row.translates,'ar_sa').description}}
                           </div>
                        </template>
                    </el-table-column>
                  
                    
                    <el-table-column label="Operations" width="100 ">
                        <template #default="scope">
                            <el-tooltip
                                class="box-item"
                                effect="dark"
                                content="edit field"
                                placement="top"
                            >
                                <font-awesome-icon :icon="['fas', 'edit']" style="width:20px" @click="handleEditField(scope.row)" class="cursor-pointer" />
                            </el-tooltip>
                             
                                
                        </template>
                    </el-table-column>
                    
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
 
</template>
<script>
export default {
    computed:{
        cachedAllFields(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.careers?.careersFields?.list || []
        },
    },
    data(){
        return{
            allFields:[],
            isAddField:false,
           
        }
    },
    mounted(){
        
        if (!this.cachedAllFields.length){
            this.getCareersFields();
        }else{
           
            this.allFields = this.cachedAllFields;
        }
    },
    
    methods:{
       
        async getCareersFields(){
            
            const response = await this.$store.dispatch('getCareersFields');
            this.allFields = response.data.data;
            
            
        },
    
        async changeFieldStatus(fieldData){
            
            let dataToSend = {
                status: fieldData.status,
                id:fieldData.id
            }
            const response = await this.$store.dispatch('changeFieldStatus',dataToSend);
            if (response.data.status == 1){
                this.getCareersFields();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }else{
                const currentField = this.allFields.find(field => field.id == fieldData.id )
                currentField.status = !currentField.status
            }
            
        },
       
        async handleAddField(){
            this.$router.push({
                name:'careers-manage-field',
            })
           
        },
        async handleEditField(field){
            await this.$store.dispatch('storeCurrentCareersFieldToView',field)
            this.$router.push({
                name:'careers-manage-field',
                params:{
                    id:field.id
                }
            })
        }
    }
}
</script>